import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useTranslation } from 'react-i18next';
import SectionLabel from '../components/SectionLabel';
import AnimatedSection from '../components/AnimatedSection';
import { ButtonPrimary, ButtonOutline } from '../components/Button';

const pulse = keyframes`0%,100%{transform:scale(1);opacity:.07}50%{transform:scale(1.06);opacity:.14}`;
const fadeUp = keyframes`from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}`;

const Section = styled.section`
  padding:150px 80px;text-align:center;position:relative;overflow:hidden;
  background:${({theme})=>theme.colors.mid};
  @media(max-width:900px){padding:80px 24px}
  @media(max-width:480px){padding:60px 16px}
`;
const BgGlow = styled.div`
  position:absolute;width:800px;height:800px;border-radius:50%;
  left:50%;top:50%;transform:translate(-50%,-50%);
  background:radial-gradient(circle,rgba(0,163,255,0.1) 0%,transparent 70%);
  animation:${pulse} 5s ease-in-out infinite;pointer-events:none;
`;
const Inner = styled.div`position:relative;z-index:2;max-width:800px;margin:0 auto`;
const Title = styled.h2`
  font-family:'Bebas Neue',sans-serif;
  font-size:clamp(58px,11vw,140px);line-height:.88;letter-spacing:.02em;margin-bottom:24px;
  .accent{background:${({theme})=>theme.gradients.brand};-webkit-background-clip:text;-webkit-text-fill-color:transparent}
`;
const Desc = styled.p`
  font-size:17px;color:${({theme})=>theme.colors.textSecondary};
  max-width:460px;margin:0 auto 50px;line-height:1.78;
`;
const Actions = styled.div`display:flex;gap:18px;justify-content:center;flex-wrap:wrap`;
const Divider = styled.div`
  width:1px;height:70px;
  background:linear-gradient(to bottom,transparent,rgba(0,163,255,0.22),transparent);
  margin:0 auto 50px;
`;
const ContactInfo = styled.div`
  margin-top:40px;display:flex;align-items:center;justify-content:center;gap:28px;flex-wrap:wrap;
`;
const InfoItem = styled.a`
  font-family:'Space Mono',monospace;font-size:10px;letter-spacing:.2em;
  color:rgba(255,255,255,.72);text-decoration:none;text-transform:uppercase;
  transition:color .3s;
  &:hover{color:#00A3FF}
`;

export default function CTA() {
  const { t } = useTranslation();

  return (
    <Section id="contato">
      <BgGlow/>
      <Inner>
        <AnimatedSection>
          <SectionLabel>{t('cta.sectionLabel')}</SectionLabel>
          <Title>{t('cta.titleLine1')}<br/><span className="accent">{t('cta.titleAccent')}</span><br/>{t('cta.titleLine3')}</Title>
          <Divider/>
          <Desc>
            {t('cta.desc')}
          </Desc>
          <Actions>
            <ButtonPrimary href="mailto:contato@guebly.com.br">
              {t('cta.btnContact')}
            </ButtonPrimary>
            <ButtonOutline href="https://www.instagram.com/gueblygames" target="_blank" rel="noopener noreferrer">
              {t('cta.btnInstagram')}
            </ButtonOutline>
            <ButtonOutline href="https://discord.gg/gueblygames" target="_blank" rel="noopener noreferrer">
              {t('cta.btnDiscord')}
            </ButtonOutline>
          </Actions>
          <ContactInfo>
            <InfoItem href="mailto:contato@guebly.com.br">contato@guebly.com.br</InfoItem>
            <InfoItem href="https://www.instagram.com/gueblygames" target="_blank" rel="noopener noreferrer">instagram · @gueblygames</InfoItem>
            <InfoItem href="https://discord.gg/gueblygames" target="_blank" rel="noopener noreferrer">discord · /gueblygames</InfoItem>
          </ContactInfo>
        </AnimatedSection>
      </Inner>
    </Section>
  );
}
